/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiResponse1ActivityLogListResponse,
  ApiResponse1Boolean,
  ApiResponse1CommentResponse,
  ApiResponse1FileResponse,
  MicrosoftAspNetCoreMvcProblemDetails,
  RevisdomAPIViewModelsEntryCreateCommentRequest,
  RevisdomAPIViewModelsEntryCreateGuestCommentRequest,
  RevisdomAPIViewModelsEntryDeleteCommentRequest,
  RevisdomAPIViewModelsEntryEditCommentRequest,
  RevisdomAPIViewModelsEntryResolveCommentRequest,
  RevisdomAPIViewModelsEntryTogglePinCommentRequest,
} from '../models/index';
import {
    ApiResponse1ActivityLogListResponseFromJSON,
    ApiResponse1ActivityLogListResponseToJSON,
    ApiResponse1BooleanFromJSON,
    ApiResponse1BooleanToJSON,
    ApiResponse1CommentResponseFromJSON,
    ApiResponse1CommentResponseToJSON,
    ApiResponse1FileResponseFromJSON,
    ApiResponse1FileResponseToJSON,
    MicrosoftAspNetCoreMvcProblemDetailsFromJSON,
    MicrosoftAspNetCoreMvcProblemDetailsToJSON,
    RevisdomAPIViewModelsEntryCreateCommentRequestFromJSON,
    RevisdomAPIViewModelsEntryCreateCommentRequestToJSON,
    RevisdomAPIViewModelsEntryCreateGuestCommentRequestFromJSON,
    RevisdomAPIViewModelsEntryCreateGuestCommentRequestToJSON,
    RevisdomAPIViewModelsEntryDeleteCommentRequestFromJSON,
    RevisdomAPIViewModelsEntryDeleteCommentRequestToJSON,
    RevisdomAPIViewModelsEntryEditCommentRequestFromJSON,
    RevisdomAPIViewModelsEntryEditCommentRequestToJSON,
    RevisdomAPIViewModelsEntryResolveCommentRequestFromJSON,
    RevisdomAPIViewModelsEntryResolveCommentRequestToJSON,
    RevisdomAPIViewModelsEntryTogglePinCommentRequestFromJSON,
    RevisdomAPIViewModelsEntryTogglePinCommentRequestToJSON,
} from '../models/index';

export interface ApiFileCommentDeleteRequest {
    revisdomAPIViewModelsEntryDeleteCommentRequest?: RevisdomAPIViewModelsEntryDeleteCommentRequest;
}

export interface ApiFileCommentPinPostRequest {
    revisdomAPIViewModelsEntryTogglePinCommentRequest?: RevisdomAPIViewModelsEntryTogglePinCommentRequest;
}

export interface ApiFileCommentPostRequest {
    revisdomAPIViewModelsEntryCreateCommentRequest?: RevisdomAPIViewModelsEntryCreateCommentRequest;
}

export interface ApiFileCommentPutRequest {
    revisdomAPIViewModelsEntryEditCommentRequest?: RevisdomAPIViewModelsEntryEditCommentRequest;
}

export interface ApiFileCommentResolvePostRequest {
    revisdomAPIViewModelsEntryResolveCommentRequest?: RevisdomAPIViewModelsEntryResolveCommentRequest;
}

export interface ApiFileEditPostRequest {
    id?: number;
    name?: string;
    thumbnail?: Blob;
    share?: Array<string>;
}

export interface ApiFileGuestCommentPostRequest {
    revisdomAPIViewModelsEntryCreateGuestCommentRequest?: RevisdomAPIViewModelsEntryCreateGuestCommentRequest;
}

export interface ApiFileIdActivityLogsGetRequest {
    id: number;
}

export interface ApiFileIdGetRequest {
    id: number;
}

export interface ApiFilePostRequest {
    file?: Blob;
    folderId?: number;
    projectId?: number;
    fileId?: number;
    status?: ApiFilePostStatusEnum;
    name?: string;
    thumbnail?: Blob;
    share?: Array<string>;
}

/**
 * 
 */
export class FileApi extends runtime.BaseAPI {

    /**
     * Bu endpoint bir comment\'i siler. Sadece comment\'i oluşturan kişi silebilir.
     * Bir comment\'i siler
     */
    async apiFileCommentDeleteRaw(requestParameters: ApiFileCommentDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1Boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/File/comment`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsEntryDeleteCommentRequestToJSON(requestParameters['revisdomAPIViewModelsEntryDeleteCommentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1BooleanFromJSON(jsonValue));
    }

    /**
     * Bu endpoint bir comment\'i siler. Sadece comment\'i oluşturan kişi silebilir.
     * Bir comment\'i siler
     */
    async apiFileCommentDelete(requestParameters: ApiFileCommentDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1Boolean> {
        const response = await this.apiFileCommentDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor, Commenter  
     * Var olan kök comment\'in pin durumunu değiştirir (resolve ile aynı desen: IsPinned true/false/null).
     */
    async apiFileCommentPinPostRaw(requestParameters: ApiFileCommentPinPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1CommentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/File/comment/pin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsEntryTogglePinCommentRequestToJSON(requestParameters['revisdomAPIViewModelsEntryTogglePinCommentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1CommentResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor, Commenter  
     * Var olan kök comment\'in pin durumunu değiştirir (resolve ile aynı desen: IsPinned true/false/null).
     */
    async apiFileCommentPinPost(requestParameters: ApiFileCommentPinPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1CommentResponse> {
        const response = await this.apiFileCommentPinPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor, Commenter  Bu endpoint yeni bir comment oluşturur.
     * Yeni bir comment oluşturur
     */
    async apiFileCommentPostRaw(requestParameters: ApiFileCommentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1CommentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/File/comment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsEntryCreateCommentRequestToJSON(requestParameters['revisdomAPIViewModelsEntryCreateCommentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1CommentResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor, Commenter  Bu endpoint yeni bir comment oluşturur.
     * Yeni bir comment oluşturur
     */
    async apiFileCommentPost(requestParameters: ApiFileCommentPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1CommentResponse> {
        const response = await this.apiFileCommentPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bu endpoint bir comment\'in text\'ini düzenler. Sadece comment\'i oluşturan kişi düzenleyebilir.
     * Bir comment\'i düzenler
     */
    async apiFileCommentPutRaw(requestParameters: ApiFileCommentPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1Boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/File/comment`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsEntryEditCommentRequestToJSON(requestParameters['revisdomAPIViewModelsEntryEditCommentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1BooleanFromJSON(jsonValue));
    }

    /**
     * Bu endpoint bir comment\'in text\'ini düzenler. Sadece comment\'i oluşturan kişi düzenleyebilir.
     * Bir comment\'i düzenler
     */
    async apiFileCommentPut(requestParameters: ApiFileCommentPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1Boolean> {
        const response = await this.apiFileCommentPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor, Commenter  Bu endpoint comment\'in resolve bilgisini değiştirir.
     * Var olan comment\'in resolve bilgisini değiştirir
     */
    async apiFileCommentResolvePostRaw(requestParameters: ApiFileCommentResolvePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1CommentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/File/comment/resolve`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsEntryResolveCommentRequestToJSON(requestParameters['revisdomAPIViewModelsEntryResolveCommentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1CommentResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor, Commenter  Bu endpoint comment\'in resolve bilgisini değiştirir.
     * Var olan comment\'in resolve bilgisini değiştirir
     */
    async apiFileCommentResolvePost(requestParameters: ApiFileCommentResolvePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1CommentResponse> {
        const response = await this.apiFileCommentResolvePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  Bu endpoint bir file üzerinde düzenleme yapmanızı sağlar. Thumbnail yüklenebilir.
     * var olan bir file\'ı düzenler
     */
    async apiFileEditPostRaw(requestParameters: ApiFileEditPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1FileResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['id'] != null) {
            formParams.append('Id', requestParameters['id'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('Name', requestParameters['name'] as any);
        }

        if (requestParameters['thumbnail'] != null) {
            formParams.append('Thumbnail', requestParameters['thumbnail'] as any);
        }

        if (requestParameters['share'] != null) {
            requestParameters['share'].forEach((element) => {
                formParams.append('Share', element as any);
            })
        }

        const response = await this.request({
            path: `/api/File/edit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1FileResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  Bu endpoint bir file üzerinde düzenleme yapmanızı sağlar. Thumbnail yüklenebilir.
     * var olan bir file\'ı düzenler
     */
    async apiFileEditPost(requestParameters: ApiFileEditPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1FileResponse> {
        const response = await this.apiFileEditPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFileGuestCommentPostRaw(requestParameters: ApiFileGuestCommentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1CommentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/File/guest-comment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsEntryCreateGuestCommentRequestToJSON(requestParameters['revisdomAPIViewModelsEntryCreateGuestCommentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1CommentResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFileGuestCommentPost(requestParameters: ApiFileGuestCommentPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1CommentResponse> {
        const response = await this.apiFileGuestCommentPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  
     * Bir dosyaya ait aktivite loglarını listeler (yalnızca Admin ve Super Admin).
     */
    async apiFileIdActivityLogsGetRaw(requestParameters: ApiFileIdActivityLogsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1ActivityLogListResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiFileIdActivityLogsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/File/{id}/activity-logs`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1ActivityLogListResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  
     * Bir dosyaya ait aktivite loglarını listeler (yalnızca Admin ve Super Admin).
     */
    async apiFileIdActivityLogsGet(requestParameters: ApiFileIdActivityLogsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1ActivityLogListResponse> {
        const response = await this.apiFileIdActivityLogsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bu endpoint ilgili id\'ye sahip file\'ın detaylarını döner.
     * File detaylarını döner
     */
    async apiFileIdGetRaw(requestParameters: ApiFileIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1FileResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiFileIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/File/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1FileResponseFromJSON(jsonValue));
    }

    /**
     * Bu endpoint ilgili id\'ye sahip file\'ın detaylarını döner.
     * File detaylarını döner
     */
    async apiFileIdGet(requestParameters: ApiFileIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1FileResponse> {
        const response = await this.apiFileIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  Bu endpoint yeni bir file oluşturur. Thumbnail yüklenebilir.
     * Yeni bir file oluşturur
     */
    async apiFilePostRaw(requestParameters: ApiFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1FileResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }

        if (requestParameters['folderId'] != null) {
            formParams.append('FolderId', requestParameters['folderId'] as any);
        }

        if (requestParameters['projectId'] != null) {
            formParams.append('ProjectId', requestParameters['projectId'] as any);
        }

        if (requestParameters['fileId'] != null) {
            formParams.append('FileId', requestParameters['fileId'] as any);
        }

        if (requestParameters['status'] != null) {
            formParams.append('Status', requestParameters['status'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('Name', requestParameters['name'] as any);
        }

        if (requestParameters['thumbnail'] != null) {
            formParams.append('Thumbnail', requestParameters['thumbnail'] as any);
        }

        if (requestParameters['share'] != null) {
            requestParameters['share'].forEach((element) => {
                formParams.append('Share', element as any);
            })
        }

        const response = await this.request({
            path: `/api/File`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1FileResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor  Bu endpoint yeni bir file oluşturur. Thumbnail yüklenebilir.
     * Yeni bir file oluşturur
     */
    async apiFilePost(requestParameters: ApiFilePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1FileResponse> {
        const response = await this.apiFilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ApiFilePostStatusEnum = {
    NeedsReview: 'NeedsReview',
    Updated: 'Updated',
    Approved: 'Approved'
} as const;
export type ApiFilePostStatusEnum = typeof ApiFilePostStatusEnum[keyof typeof ApiFilePostStatusEnum];
